var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"photography-credit"},[_c('IconCamera',{staticClass:"photography-credit__icon"}),_vm._v(" "+_vm._s(_vm.strapline)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }